import cx from "classnames"
import React, { useState } from "react"

import * as styles from "./styles.module.scss"
import { FlowQuestionId } from "types"

export interface SummaryBarProps {
  editToggleCallback?: () => void
  userAnswers: any
}

// TODO: Factor these out to be part of the flow JSON
const itemMap = {
  [FlowQuestionId.LoanBalance]: "Current Mortgage",
  [FlowQuestionId.LoanRate]: "Current Rate",
  [FlowQuestionId.CashOutAmount]: "Cash needed",
  [FlowQuestionId.MovingTimeline]: "Planned time in home",
}

const SummaryBar: React.FC<SummaryBarProps> = ({
  editToggleCallback,
  userAnswers = {},
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggle = () => {
    setIsOpen(!isOpen)

    if (editToggleCallback) editToggleCallback()
  }

  const items = Object.keys(itemMap).map((i) => {
    return (
      <li
        className={cx({
          [styles.item]: true,
          [styles.hasAnswer]: userAnswers[i],
        })}
        data-flow-key={i}
        key={`summary-item-${i}`}
      >
        <a className={styles.link}>
          <h6 className={styles.label}>{itemMap[i]}</h6>
          <h2 className={styles.value}>
            <span className={styles.underline}>
              {userAnswers[i] && userAnswers[i].display}
            </span>
          </h2>
        </a>
      </li>
    )
  })

  return (
    <div
      className={styles.bar}
      data-js-flow-summary-bar={isOpen ? "open" : "close"}
      onClick={() => toggle()}
    >
      <div className={styles.pagePadding}>
        <div className={styles.container}>
          <ul className={styles.list}>{items}</ul>
          <div className={styles.buttonWrap}>
            <button className={styles.button}>
              <span className={styles.edit}>Edit</span>
              <i
                className={cx({
                  [styles.arrow]: true,
                  ["bsk-icon-arrow-down"]: true,
                })}
              ></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SummaryBar
